import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { CapacityCategoriesPersonsDataGrid } from '../../components/datagrid/CapacityCategoriesPersonsDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { CapacityCategoryPerson } from '../../types/capacityCategory.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function CapacityCategoriesPersons() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Capacity categories persons',
      steps: [{ name: 'Home', pathToCutCount: 1 }],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<CapacityCategoryPerson[]>(
    `${API_URL.CAPACITY_CATEGORY_PERSON_LIST}?visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/capacity-categories-persons/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <CapacityCategoriesPersonsDataGrid data={data} handleEdit={handleEditButton} />
    </PageContentWrapper>
  );
}
export default CapacityCategoriesPersons;
